/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, MenuDropdown } from '@/components/Common';
import UploadQuizz from '@/components/Views/UploadQuizz/UploadQuizz';
import QuizzForm from './GeneratedQuizForm';
import { useGeneratedQuizz } from './generatedQuiz.hook';
import { Modal } from '@/components/Layout';
import { ListItem } from '@/components/Ui';
import { QuestionOutput } from '@/api/gql/graphql';
import { useGeneratedModule } from '../GeneratedModule/generatedModule.hook';
import { useMemo } from 'react';

export const GeneratedQuiz = ({ moduleId }: { moduleId: string }) => {
  const {
    selectedGeneratedQuizz,
    quizzMenuItems,
    isOpenQuizDeleteModal,
    openQuizDeleteModal,
    isDeletePending,
  } = useGeneratedQuizz();

  const { modules, deleteGeneratedQuizz } = useGeneratedModule();
  const quizzList = modules.find((module) => module.section._id === moduleId);

  const quizzes = useMemo(() => {
    return quizzList?.quizz || [];
  }, [quizzList?.quizz]);

  return (
    <>
      <div className="grid grid-cols-[45%_auto] items-start mt-6">
        <UploadQuizz type="quizz" />
        <div className="pr-9 pb-6 flex flex-col gap-5 pt-2 h-[calc(100vh_-_110px)] overflow-y-scroll">
          <h3 className="text-white text-[27.99px] font-bold text-left">
            Ajouter question
          </h3>
          <QuizzForm moduleId={moduleId} />
        </div>
        <div className="flex flex-col gap-2 pl-10 pr-5 pt-2 h-[calc(100vh_-_110px)] overflow-y-auto scrollbar-hide">
          <div className="flex justify-between items-center">
            <h3 className="text-white text-[27.99px] font-bold text-left">
              Liste des questions
              <span className="text-slateGray text-base font-light block">
                {quizzes.length} Questions
              </span>
            </h3>
            <div className="flex gap-2">
              <Button
                title="Upload"
                icon={<i className="pi pi-upload"></i>}
                iconPosition="right"
                className="!px-12"
              />
            </div>
          </div>
          <div className="flex flex-col">
            {quizzes.map((item: QuestionOutput) => {
              return (
                <div key={item._id}>
                  <ListItem
                    connector
                    listItemStyle="!bg-black"
                    leftBorderColor="#FEC200"
                    connectorStyle="before:h-[calc(100%_-_20px)]"
                    focused={item._id === selectedGeneratedQuizz?._id}
                    subItems={item.responses
                      .filter((res) => res.response !== '')
                      .map((res) => ({
                        connector: true,
                        children: (
                          <div>
                            <p className="text-white text-[10px]">
                              {res.response}
                            </p>
                          </div>
                        ),
                        leftBorderColor: res.isRight ? '#2ecc71' : '#EA242C',
                      }))}
                  >
                    <div className="flex justify-between">
                      <div className="flex flex-col">
                        <p>{item.name}</p>
                        <p className="text-[9.75px] font-normal leading-3 text-left text-[#939393] pt-1">
                          Type {item.type}
                        </p>
                      </div>
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                      >
                        <MenuDropdown
                          menuItems={quizzMenuItems(item)}
                          dotsStyle="hover:bg-[#FEC20033]"
                        />
                      </div>
                    </div>
                  </ListItem>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Modal de suppression */}
      <Modal
        isOpen={isOpenQuizDeleteModal}
        onClose={openQuizDeleteModal}
        modalStyle="bg-[#2A2A2A] min-w-[23.4375rem]"
        headerStyle="bg-[#2A2A2A]"
      >
        <div className="flex flex-col gap-1">
          <h3 className="text-white text-xl font-bold text-center mb-2">
            Supprimer la question
          </h3>
          <p className="text-center text-gray-400 mx-auto my-0">
            Êtes-vous sûr de vouloir supprimer ?{' '}
          </p>
          <div className="flex justify-between items-center gap-6 mt-4">
            <Button
              onClick={openQuizDeleteModal}
              title="Annuler"
              className="!bg-completed hover:!outline-completed hover:!text-completed hover:!bg-hoverColor text-white !px-16"
            />
            <Button
              className="!px-16"
              title={isDeletePending ? 'Suppression en cours...' : 'Supprimer'}
              onClick={() => {
                if (selectedGeneratedQuizz?._id) {
                  deleteGeneratedQuizz(selectedGeneratedQuizz._id);
                  openQuizDeleteModal();
                }
              }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};
